

import api from "../request";
import { Promise } from "q";



function getCenters(reqData) {
  return api
    .post("center/get",{reqData}||{})
    .then(({ data }) => {
      return data;
    })
}
function getCentersByUser(reqData) {
  return api
    .post("center/get-by-user",{reqData}||{})
    .then(({ data }) => {
      return data;
    })
}

function getBatches(reqData) {
  return api
    .post("batch/get", {reqData})
    .then(({ data }) => {
      return data;
    })
}
function getBatchForScheduleTest(reqData) {
  return api
    .post("batch/get-batch-for-schedule-test", {reqData})
    .then(({ data }) => {
      return data;
    })
}
function upsertCenter(reqData) {
  return api
    .post("center/upsert", {reqData})
    .then(({ data }) => {
      return data;
    })
}
function upsertBatch(reqData) {
  return api
    .post("batch/upsert", {reqData})
    .then(({ data }) => {
      return data;
    })
}
function deleteBatch(reqData) {
  return api
    .post("batch/delete", {reqData})
    .then(({ data }) => {
      return data;
    })
}
function deleteCenter(reqData) {
  return api
    .post("center/delete", {reqData})
    .then(({ data }) => {
      return data;
    })
}
function getBatchStudentsSubjectTree(reqData) {
  return api
    .post("users/get-batch-students-subject-tree", {reqData})
    .then(({ data }) => {
      return data;
    })
}

function getCenterBatchesBySchedule(reqData) {
  return api
    .post("center/get-by-schedule", {reqData})
    .then(({ data }) => {
      return data;
    })
}


export default {  
  getCenters,
  getCentersByUser,
  getBatches,  
  upsertCenter,
  upsertBatch,
  deleteCenter,
  deleteBatch,
  getBatchForScheduleTest,
  getBatchStudentsSubjectTree,
  getCenterBatchesBySchedule
};
